import { extend, localize } from "vee-validate";
import { required, required_if, numeric, size, confirmed, email, digits, min_value, max_value, is_not, oneOf } from "vee-validate/dist/rules";
import zh_TW from "vee-validate/dist/locale/zh_TW.json";
import moment from 'moment';
import i18n from './i18n';

// Install rules
extend("required", required);
extend("required_if", required_if);
extend("size", size);
extend("numeric", numeric);
extend("confirmed", confirmed);
extend("email", email);
extend("digits", digits);
extend("min_value", min_value);
extend("max_value", max_value);
extend("is_not", is_not);
extend("oneOf", oneOf);

extend('id_date', (value, [days]) => {
  let date = moment(value, 'YYYY-MM-DD', true).startOf('day');
  days = days || 0;

  if (date.isValid()) {
    const diff = date.diff(moment().startOf('day'), 'days');

    if (diff < 0) {
      return "「{_field_}」已過期，請轉問題件。";
    }

    if (diff < days) {
      return `「{_field_}」在${days}天內過期，請轉問題件。`;
    }
  }

  return true;
});

extend('key_in_date', (value, [loose]) => {
  let date = moment(value, 'YYYY-MM-DD', loose != "true");

  return date.isValid() ? true : `「{_field_}」${i18n.t('日期輸入不正確')}！`;
});
extend('flight_no', (value) => {
  return /^[A-Z0-9]{2}[0-9]{1,4}$/.test(value) || '「{_field_}」代碼格式不正確！';
});

extend('birthday', (value) => {
  let date = moment(value, 'YYYY-MM-DD', true);
  if (date.isValid()) {
    const dateOf18yearsAgo = moment().subtract(18, 'years');
    if (date < dateOf18yearsAgo) {
      return true;
    }

    return i18n.t("未滿18歲");
  }

  return `「{_field_}」${i18n.t('日期輸入不正確')}！`;
});

// Install messages
zh_TW.messages.confirmed = "{_field_} 輸入的不一致";
localize('zh_TW', zh_TW);
